export default __webpack_public_path__ + "static/media/correct.32aecbc3.svg";